import {
    put, takeLatest, call
} from 'redux-saga/effects';
import { axios } from '../client';
import {
    GET_GUEST_CHECKOUT,
    getGuestCheckout,
    UPDATE_GUEST_CHECKOUT,
    updateGuestCheckout,
    UPDATE_GUEST_CHECKOUT_CART_ITEM,
    updateGuestCheckoutCartItem,
    SUBMIT_GUEST_CHECKOUT,
    submitGuestCheckout,
    GUEST_CHECKOUT_REMOVE_CART_ITEM,
    guestCheckoutRemoveCartItem,
    updateGuestCheckoutDeliveryByPurchaser,
} from "../actions/guestCheckout";
import {getStripePartsFromClientSecret} from "../utils";

function* handleGuestCheckoutRemoveCartItem({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const response = yield call(axios.post, `${window.react_giftya_base_url}/cart/delete/${payload.cartItem.id}`);

        yield put(guestCheckoutRemoveCartItem({
            guestCheckoutRemoveCartItemSuccess: true,
            guestCheckoutRemoveCartItemCartItem: payload.cartItem,
            guestCheckout: response.data.guestCheckout,
        }, {'sent': true}));

    } catch (error) {
        yield put(guestCheckoutRemoveCartItem(error, {}, true));
    }
}
export function* watchGuestCheckoutRemoveCartItem() {
    yield takeLatest(GUEST_CHECKOUT_REMOVE_CART_ITEM, handleGuestCheckoutRemoveCartItem);
}




function* handleGetGuestCheckout({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const response = yield call(axios.get, `${window.react_giftya_base_url}/api/guest-checkout`);

        yield put(getGuestCheckout({
            guestCheckout: response.data,
            getGuestCheckoutSuccess: true
        }, {'sent': true}));

    } catch (error) {
        yield put(getGuestCheckout(error, {}, true));
    }
}
export function* watchGetGuestCheckout() {
    yield takeLatest(GET_GUEST_CHECKOUT, handleGetGuestCheckout);
}

function* handleUpdateGuestCheckout({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    const messages = {
        phoneNumber: 'We are unable to send a text to this number. Landline and international numbers are not supported. Please enter a valid phone number.'
    };

    try {
        const params = new URLSearchParams();
        if ('email' in payload) {params.append('email', payload.email);}
        if ('firstName' in payload) {params.append('firstName', payload.firstName);}
        if ('lastName' in payload) {params.append('lastName', payload.lastName);}
        if ('phoneNumber' in payload) {params.append('phoneNumber', payload.phoneNumber);}

        if ('ccNumber' in payload) {params.append('ccNumber', payload.ccNumber);}
        if ('ccName' in payload) {params.append('ccName', payload.ccName);}
        if ('ccExpiration' in payload) {params.append('ccExpiration', payload.ccExpiration);}
        if ('ccCode' in payload) {params.append('ccCode', payload.ccCode);}
        if ('ccType' in payload) {params.append('ccType', payload.ccType.charAt(0).toUpperCase() + payload.ccType.slice(1));}
        if ('ccLastFour' in payload) {params.append('ccLastFour', payload.ccLastFour);}
        if ('savePaymentInformation' in payload) {params.append('savePaymentInformation', payload.savePaymentInformation);}

        if ('billingAddress1' in payload) {params.append('billingAddress1', payload.billingAddress1);}
        if ('billingAddress2' in payload) {params.append('billingAddress2', payload.billingAddress2);}
        if ('billingCity' in payload) {params.append('billingCity', payload.billingCity);}
        if ('billingState' in payload) {params.append('billingState', payload.billingState);}
        if ('billingZip' in payload) {params.append('billingZip', payload.billingZip);}
        if ('billingAccountId' in payload) {params.append('billingAccountId', payload.billingAccountId);}

        if ('visiblePhoneId' in payload) {params.append('visiblePhoneId', payload.visiblePhoneId);}
        if ('creditTotal' in payload) {params.append('creditTotal', payload.creditTotal);}
        if ('dateSubmitted' in payload) {params.append('dateSubmitted', payload.dateSubmitted);}
        if ('receipt' in payload) {params.append('receipt', payload.receipt);}
        if ('cart' in payload) {params.append('cart', payload.cart);}

        if ('paypalPayerId' in payload) {params.append('paypalPayerId', payload.paypalPayerId)}
        if ('paypalAuthorizationId' in payload) {params.append('paypalAuthorizationId', payload.paypalAuthorizationId)}
        if ('paypalBuyerEmail' in payload) {params.append('paypalBuyerEmail', payload.paypalBuyerEmail)}
        if ('paymentMethod' in payload) {params.append('paymentMethod', payload.paymentMethod )}

        if ('paymentIntentClientSecret' in payload) {params.append('paymentIntentClientSecret', payload.paymentIntentClientSecret )}
        if ('stripePaymentMethodId' in payload) {params.append('stripePaymentMethodId', payload.stripePaymentMethodId )}
        if ('stripePaymentIntentId' in payload) {params.append('stripePaymentIntentId', payload.stripePaymentIntentId )}

        if ('recaptchaResponse' in payload) {params.append('recaptchaResponse', payload.recaptchaResponse )}


        if ('phoneNumber' in payload) {

            let phoneNumber = payload.phoneNumber.replace(/[^0-9]/g, '');
            const message = messages.phoneNumber;

            if (phoneNumber.charAt(0) !== '1') {
                phoneNumber = '1' + phoneNumber;
            }
            if (phoneNumber.length !== 11) {
                yield put(updateGuestCheckout({message}, {}, true));
            }
            const sessionStorageKeyPrefix = 'giftya_sms_deliverability_status_';

            // Check session storage value if supported.
            let smsDeliverabilityStatus = typeof(Storage) !== 'undefined' ? sessionStorage.getItem(sessionStorageKeyPrefix + phoneNumber) : null;
            if (smsDeliverabilityStatus !== null && parseInt(smsDeliverabilityStatus) !== 1) {
                yield put(updateGuestCheckout({message}, {}, true));
            }

            try {
                const response = yield call(axios.get, `${window.api_url}/site/twilio/deliverability?phone_number=${phoneNumber}`);
                sessionStorage.setItem(sessionStorageKeyPrefix + phoneNumber, response.data.can_send_sms);

                if (parseInt(response.data.can_send_sms) !== 1) {
                    yield put(updateGuestCheckout({message}, {}, true));
                }

            } catch (error) {
                sessionStorage.setItem(sessionStorageKeyPrefix + phoneNumber, smsDeliverabilityStatus);
            }
        }
        
        const response = yield call(axios.post, `${window.react_giftya_base_url}/api/guest-checkout/update`, params);

        yield put(updateGuestCheckout({
            guestCheckout: response.data,
            updateGuestCheckoutSuccess: true
        }, { 'sent': true }));

    } catch (error) {
        yield put(updateGuestCheckout(error, {}, true));
    }
}
export function* watchUpdateGuestCheckout() {
    yield takeLatest(UPDATE_GUEST_CHECKOUT, handleUpdateGuestCheckout);
}

function* handleUpdateGuestCheckoutCartItem({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    if ('delivery_by_purchaser' in payload) {
        return;
    }

    if (payload.delivery_method === 'sms') {

        let phoneNumber = payload.sms_recipient.replace(/[^0-9]/g, '');
        const message = 'We are unable to send a text to this number. Landline and international numbers are not supported. Please enter a valid phone number.';

        if (phoneNumber.charAt(0) !== '1') {
            phoneNumber = '1' + phoneNumber;
        }
        if (phoneNumber.length !== 11) {
            yield put(updateGuestCheckoutCartItem({message}, {}, true));
        }
        const sessionStorageKeyPrefix = 'giftya_sms_deliverability_status_';

        // Check session storage value if supported.
        let smsDeliverabilityStatus = typeof(Storage) !== 'undefined' ? sessionStorage.getItem(sessionStorageKeyPrefix + phoneNumber) : null;
        if (smsDeliverabilityStatus !== null && smsDeliverabilityStatus !== 'null' && parseInt(smsDeliverabilityStatus) !== 1) {
            yield put(updateGuestCheckoutCartItem({message}, {}, true));
        }

        try {
            const response = yield call(axios.get, `${window.api_url}/site/twilio/deliverability?phone_number=${phoneNumber}`);
            sessionStorage.setItem(sessionStorageKeyPrefix + phoneNumber, response.data.can_send_sms);

            if (parseInt(response.data.can_send_sms) !== 1) {
                yield put(updateGuestCheckoutCartItem({message}, {}, true));
            }

        } catch (error) {
            sessionStorage.setItem(sessionStorageKeyPrefix + phoneNumber, smsDeliverabilityStatus);
        }
    }


    try {
        const params = new URLSearchParams();
        if ('id' in payload) {params.append('id', payload.id);}
        if ('date_send' in payload) {params.append('date_send', payload.date_send === 'null' ? null : payload.date_send);}
        if ('sms_recipient' in payload) {params.append('sms_recipient', payload.sms_recipient);}
        if ('email_recipient' in payload) {params.append('email_recipient', payload.email_recipient);}
        if ('delivery_method' in payload) {params.append('delivery_method', payload.delivery_method);}
        if ('message' in payload) {params.append('message', payload.message);}

        const response = yield call(axios.post, `${window.react_giftya_base_url}/api/guest-checkout/update-cart-item`, params);

        yield put(updateGuestCheckoutCartItem({
            guestCheckout: response.data,
            updateGuestCheckoutCartItemSuccess: true
        }, {'sent': true}));

    } catch (error) {
        yield put(updateGuestCheckoutCartItem(error, {}, true));
    }
}
export function* watchUpdateGuestCheckoutCartItem() {
    yield takeLatest(UPDATE_GUEST_CHECKOUT_CART_ITEM, handleUpdateGuestCheckoutCartItem);
}

function* handleUpdateGuestCheckoutPurchaserDelivery({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    if ('delivery_by_purchaser' in payload) {
        yield put(updateGuestCheckoutDeliveryByPurchaser({
            guestCheckoutPurchaserDelivery: payload,
            updateGuestCheckoutCartItemSuccess: true
        }, {'sent': true}));
    }
}
export function* watchUpdateGuestCheckoutPurchaserDelivery() {
    yield takeLatest(UPDATE_GUEST_CHECKOUT_CART_ITEM, handleUpdateGuestCheckoutPurchaserDelivery);
}


function* handleSubmitGuestCheckout({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    let response = {data: {}};

    try {
        const response = yield call(axios.post,
            `${window.react_giftya_base_url}/api/guest-checkout/submit`, {
                ...payload,
                stripe_payment_intent: payload.stripe_payment_intent,
                stripe_payment_method: payload.stripe_payment_method
            }
        );

        yield put(submitGuestCheckout({
            submitGuestCheckoutSuccess: true,
            orderId: response.data.orderId,
            submitGuestCheckoutEventTrackingData: payload,
            submitGuestCheckoutVisiblePhoneId: response.data.visiblePhoneId
        }, {'sent': true}));

    } catch (error) {
        yield put(submitGuestCheckout(error, {}, true));
    }

    if (response.data.canceled_auth) {

        let idempotencyKey = '';
        let clientSecret = '';

        // try getting a new session ID / idempotency key
        try {
            const response = yield call(axios.post, `${window.react_giftya_base_url}/api/session/migrate`);
            idempotencyKey = response.data;
        } catch (error) {
            yield put(submitGuestCheckout(error, {}, true));
        }


        // try creating new intent with new idempotencyKey and amount
        try {
            const params = new URLSearchParams();
            params.append('amount', payload.cartTotal * 100);
            params.append('idempotency_key', idempotencyKey);

            const response = yield call(axios.post, `${window.api_url}/site/payment/intent`, params);
            clientSecret = response.data.data.client_secret;

        } catch (error) {
            yield put(submitGuestCheckout(error, {}, true));
        }

        // try resubmitting the order with new payment intent
        try {
            const response = yield call(axios.post,
                `${window.react_giftya_base_url}/api/guest-checkout/submit`, {
                    ...payload,
                    stripe_payment_intent: getStripePartsFromClientSecret(clientSecret).payment_intent,
                }
            );

            yield put(submitGuestCheckout({
                submitGuestCheckoutSuccess: true,
                orderId: response.data.orderId,
                submitGuestCheckoutEventTrackingData: payload,
                submitGuestCheckoutVisiblePhoneId: response.data.visiblePhoneId
            }, {'sent': true}));

        } catch (error) {

        }
    }
    yield put(submitGuestCheckout(error, {}, true));
}
export function* watchSubmitGuestCheckout() {
    yield takeLatest(SUBMIT_GUEST_CHECKOUT, handleSubmitGuestCheckout);
}

